export default {
    round(value, precision) {
        var multiplier = Math.pow(10, precision || 1);
        return Math.round(value * multiplier) / multiplier;
    }
}



// WEBPACK FOOTER //
// ./src/filters/index.js